import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineRecordSchema, defineValidation } from "../../common/validation.common";
import { SettlementStatusEnum } from "../../data/enums";

export namespace FinanceTaxValidation {
    export const Record = defineValidation(
        defineRecordSchema({
            filters: v.object({
                status: v.optional(v.picklist(SettlementStatusEnum.values)),
                associateId: v.optional(v.string()),
            }),
        }),
    );

    export const InvoiceRecord = defineValidation(BaseRecordSchema);

    export const CreateSettlement = defineValidation(
        v.object({
            settlementDate: baseVals.isoDate("Tanggal Penyetoran Pajak"),
        }),
    );

    export const GenerateExport = defineValidation(
        v.object({
            id: baseVals.string(),
        }),
    );
}
